"use strict";

var BottleneckError;
BottleneckError = class BottleneckError extends Error {};
module.exports = BottleneckError;


//////////////////
// WEBPACK FOOTER
// ./~/bottleneck/lib/BottleneckError.js
// module id = jU6A
// module chunks = 1